import { render } from "./UiAppbarBack.vue?vue&type=template&id=14fb6236&ts=true"
import script from "./UiAppbarBack.vue?vue&type=script&lang=ts"
export * from "./UiAppbarBack.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ni/IdeaProjects/pioneer/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__